import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem("npw_token")) { setLoading(false); return; }
    api.get("/auth/me").then(r => setUser(r.data)).catch(() => { localStorage.removeItem("npw_token"); setUser(null); }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("npw_token", data.access_token);
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.access_token) localStorage.setItem("npw_token", data.access_token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("npw_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, register, logout, setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function fmtErr(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => {
    const field = Array.isArray(e?.loc) ? e.loc.filter(p => p !== "body").join(" ") : "";
    if (e?.type === "string_too_short" && field === "password") return "Password must be at least 10 characters.";
    if (e?.type === "string_too_short" && field) return `${field} is too short.`;
    if (e?.type === "value_error" && e?.msg) return e.msg.replace(/^Value error,\s*/i, "");
    return e?.msg || JSON.stringify(e);
  }).join(" ");
  return String(detail);
}
